/**
 * ¿`img` es una referencia de fotografía utilizable? Los datos heredados contienen NULL, cadenas vacías y los textos
 * literales «null» / «undefined» (resto de un envío de formulario sin foto): con ellos NO se debe pedir ninguna URL
 * (se construiría `<base>null`) y se usa directamente la imagen predeterminada. Cualquier otro valor se considera una
 * referencia válida: no se restringe el formato para no impedir fotografías futuras.
 */
export function tieneFoto(img: unknown): img is string {
  if (typeof img !== 'string') return false;
  const valor = img.trim().toLowerCase();
  return valor !== '' && valor !== 'null' && valor !== 'undefined';
}
